import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import MaterialUITypography, { TypographyProperties } from './Typography';

const overlinePropertyTypes = {
  children: PropTypes.node,
  tag: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.string,
};

type OverlineProperties = InferProps<typeof overlinePropertyTypes> & {
  tag?: TypographyProperties['tag'];
  variant?: TypographyProperties['variant'];
  className?: string;
};

const Overline = ({
  children, tag, className, variant,
}: OverlineProperties) => (
  <MaterialUITypography
    tag={tag ?? 'span'}
    className={className}
    variant={variant ?? 'overline'}
    color="primary"
  >
    {children}
  </MaterialUITypography>
);

Overline.propTypes = overlinePropertyTypes;

const StyledOverline = styled(
  Overline as React.ComponentType<OverlineProperties>,
)`
  && {
    line-height: 1rem;
    letter-spacing: 0.07rem;
  }
`;

export default StyledOverline;
